/** Shared fallback for wallet / coin thumbnails */
export const WALLET_FALLBACK_ICON = "/images/AnnouncementImg/activities_icon.png";

export function fallbackCoinImg(e) {
  e.target.src = WALLET_FALLBACK_ICON;
}
